import localePl from '@angular/common/locales/pl';
import { ActiveFilterListComponent } from './components/filters/active-filter-list/active-filter-list';
import { CdkTableModule } from '@angular/cdk/table';
import { CloseDialogComponent } from './components/form-viewer/close-dialog/close-dialog.component';
import { CommonModule, registerLocaleData } from '@angular/common';
import { DasherDatePipe } from './pipes/secure/dasher-date.pipe';
import { DasherPipe } from './pipes/secure/dasher.pipe';
import { DataService } from './services/data/data.service';
import { DetailsComponent } from './components/details/details.component';
import { EllipsisPipe } from './pipes/secure/ellipsis.pipe';
import { FileDisplayerComponent } from './components/file-displayer/file-displayer.component';
import { FilterComponent } from './components/filters/filter/filter.component';
import { FiltersComponent } from './components/filters/filters.component';
import { FilterSelectionComponent } from './components/filters/filter-selection/filter-selection.component';
import { FiltersService } from './services/filters/filters.service';
import { FloatingActionButtonComponent } from './components/floating-action-button/floating-action-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormViewerComponent } from './components/form-viewer/form-viewer.component';
import { InfoPopup } from './components/info-popup/info-popup';
import { ListDisplayerComponent } from './components/list-displayer/list-displayer.component';
import { ListRendererComponent } from './components/list/list.component';
import { LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { MapComponent } from './components/map/map.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule, MatDialogModule, MatDialogRef, MatSnackBarModule } from '@angular/material';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { OfflineTableFilterService } from './services/filters/offline-table-filter.service';
import { ProcessService } from './services/process/process.service';
import { RemovalConfirmationDialog } from './components/table/removal-confirmation-dialog/removal-confirmation-dialog.component';
import { ReportService } from './services/report/report.service';
import { SecurePipe } from './pipes/secure/secure.pipe';
import { SimpleFiltersComponent } from './components/simple-filters/simple-filters.component';
import { SimpleFiltersDialogComponent } from './components/simple-filters/simple-filters-dialog/simple-filters-dialog.component';
import { SimpleFiltersService } from './services/simple-filters/simple-filters.service';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TableCellComponent } from './components/table/cell/cell.component';
import { TableFilterComponent } from './components/table/filter/table-filter.component';
import { TableRendererComponent } from './components/table/table.component';
import { TableWithFloatingActionButtonComponent } from './components/table-with-floating-action-button/table-with-floating-action-button.component';
import { DataViewListElementMenu } from './components/data-view-list-element-menu/data-view-list-element-menu';
import { MatMenuModule } from '@angular/material/menu';
import { DataViewDataSource } from './services/data-view-data-source/data-view-data-source.class';
import { ProcessFormService } from './services/process/process-form.service';
import { SellionsFormsModule } from '../../../../../sellions_forms/projects/forms/src/lib/forms.module';
import { FoldingSpinnerComponent } from './components/folding-spinner/folding-spinner.component';
import { DisplayFormService } from './services/form/display-form.service';
import { CreatorDataSource } from './data-sources/creator-data-source';
import {MapsService} from "./services/maps.service";

registerLocaleData(localePl);

@NgModule({
  declarations: [
    ListRendererComponent,
    DataViewListElementMenu,
    TableRendererComponent,
    FloatingActionButtonComponent,
    TableWithFloatingActionButtonComponent,
    DetailsComponent,
    FileDisplayerComponent,
    ListDisplayerComponent,
    FiltersComponent,
    FilterSelectionComponent,
    FilterComponent,
    ActiveFilterListComponent,
    RemovalConfirmationDialog,
    SecurePipe,
    EllipsisPipe,
    DasherPipe,
    DasherDatePipe,
    SpinnerComponent,
    TableFilterComponent,
    TableCellComponent,
    InfoPopup,
    SimpleFiltersComponent,
    SimpleFiltersDialogComponent,
    FormViewerComponent,
    CloseDialogComponent,
    MapComponent,
    FoldingSpinnerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatPaginatorModule,
    CdkTableModule,
    MatSortModule,
    MatButtonModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    SellionsFormsModule,
    MatSnackBarModule,
    MatIconModule,
    MatMenuModule,
  ],
  exports: [
    ListRendererComponent,
    TableRendererComponent,
    FloatingActionButtonComponent,
    TableWithFloatingActionButtonComponent,
    DetailsComponent,
    FileDisplayerComponent,
    ListDisplayerComponent,
    FiltersComponent,
    FilterSelectionComponent,
    ActiveFilterListComponent,
    SpinnerComponent,
    TableFilterComponent,
    TableCellComponent,
    InfoPopup,
    SimpleFiltersComponent,
    SimpleFiltersDialogComponent,
    DataViewListElementMenu,
    MapComponent,
    FoldingSpinnerComponent,
    DasherPipe,
    DasherDatePipe,
  ],
  providers: [
    CreatorDataSource,
    DataService,
    DisplayFormService,
    FiltersService,
    MapsService,
    OfflineTableFilterService,
    ReportService,
    SimpleFiltersService,
    ProcessService,
    ProcessFormService,
    { provide: LOCALE_ID, useValue: 'pl-PL' },
    {
      provide: MatDialogRef,
      useValue: {},
    },
    { provide: 'DataViewDataSource', useClass: DataViewDataSource },
  ],
  entryComponents: [
    FilterSelectionComponent,
    RemovalConfirmationDialog,
    InfoPopup,
    SimpleFiltersDialogComponent,
    FormViewerComponent,
    CloseDialogComponent,
    MapComponent,
    FileDisplayerComponent,
  ],
})
export class SellionsLayoutRendererLibModule {
  public static forRoot(environment: any): ModuleWithProviders {
    return {
      ngModule: SellionsLayoutRendererLibModule,
      providers: [
        {
          provide: 'env',
          useValue: environment,
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/sellions-layout-renderer-lib.module.ts